export const flashOnlyImportant = 'flashOnlyImportant'
